import { classes } from "common/theme/theme";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import React, { FunctionComponent } from "react";
import VeselkaIcon from "portal/images/icons/veselka.svg?react";

/** Display name for a Veselka crop in Carbon Crop association UI. */
export const veselkaCropAssociationName = (
  t: TFunction,
  crop: { commonName: string; archived?: boolean }
): string =>
  crop.archived
    ? t("components.carbonCrop.unassociatedAlert.archivedSuffix", {
        name: crop.commonName,
      })
    : crop.commonName;

interface VeselkaCropLabelProps {
  crop: { commonName: string; archived?: boolean };
  className?: string;
  showIcon?: boolean;
}

export const VeselkaCropLabel: FunctionComponent<VeselkaCropLabelProps> = ({
  crop,
  className,
  showIcon = true,
}) => {
  const { t } = useTranslation();
  const name = veselkaCropAssociationName(t, crop);
  return (
    <span
      className={classes("inline-flex items-center gap-1 min-w-0", className)}
    >
      {showIcon ? <VeselkaIcon className="shrink-0" /> : undefined}
      <span className={classes("truncate", crop.archived && "italic")}>
        {name}
      </span>
    </span>
  );
};
